import { Component, Input, OnInit } from '@angular/core';

import { MonitorService } from '../../../core/services/core.monitor.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { UserService } from '../../../core/services/core.user.service';

import * as _ from 'lodash';

@Component({
    selector: 'monitor-wiki',
    template: `<a id="wikiPageMonbtn" *ngIf="showMonitor" class="btn"
    title="{{'Toggle monitor for this page/all pages/none' | translate}}"
    (click)="toggleMonitor()"
    [ngClass]="{ 'btn-success': monitor.choice == 'full', 'btn-primary': monitor.choice == 'page', 'btn-trans': monitor.choice == 'none' }">
    <i class="glyphicon" style="margin-right: .25em;"
    [ngClass]="{ 'glyphicon-eye-open': ['full', 'page'].includes(monitor.choice), 'glyphicon-eye-close': monitor.choice == 'none' }"></i>
    <span>{{monitorText}}</span>
</a>`
})
export class MonitorWikiComponent implements OnInit {

    @Input() project: any = null;
    @Input() wikiPage: any = null;

    private monitorOptions: any = {};
    protected monitor: any = null;

    protected monitorText: String = '';
    protected showMonitor: boolean = false;

    constructor(
        private monitorService: MonitorService,
        private gfTranslateService: GfTranslateService,
        private userService: UserService
    ) { }

    ngOnInit() {
        this.monitorOptions = {};
        this.monitorOptions[this.gfTranslateService.translate('Off')] = 'none';
        this.monitorOptions[this.gfTranslateService.translate('This Page')] = 'page';
        this.monitorOptions[this.gfTranslateService.translate('All Pages')] = 'full';

        this.monitor = { choice: _.get(this.wikiPage, 'rel.monitor', 'none') };
        this.monitorText = _.capitalize(this.monitor.choice);
        this.showMonitor = this.userService.session.hasUser() &&
            _.get(this.wikiPage, 'id', 0) > 0;
    };

    toggleMonitor = () => {
        switch (this.monitor.choice) {
            case 'none': // => page
                this.monitorService.set('wikipage', this.wikiPage.id);
                this.monitor.choice = 'page';
                this.monitorText = _.capitalize(this.monitor.choice);
                _.set(this.wikiPage, 'rel.monitor', 'page');
                break;

            case 'page': // => full
                this.monitorService.set('wiki', this.project.id);
                this.monitorService.unset('wikipage', this.wikiPage.id);
                this.monitor.choice = 'full';
                this.monitorText = _.capitalize(this.monitor.choice);
                _.set(this.wikiPage, 'rel.monitor', 'full');
                break;

            case 'full': // => none
                this.monitorService.unset('wiki', this.project.id);
                this.monitor.choice = 'none';
                this.monitorText = _.capitalize(this.monitor.choice);
                _.set(this.wikiPage, 'rel.monitor', 'none');
                break;
        }
    };
}